import httpService from '@/services/httpService'

export const types = {
  SET_SERPS: 'serpTracker/SET_SERPS'
}

const state = {
  serps: []
}

const mutations = {
  [types.SET_SERPS]: function (state, serps) {
    state.serps = serps
  }
}

const actions = {
  getSerpData: async function ({ commit }, { clientId, filters }) {
    const params = { filters: JSON.stringify(filters) }
    const response = await httpService.get(`/serp-tracker/${clientId}`, { params })
    if (!response || !response.data) {
      return []
    }
    commit(types.SET_SERPS, response.data)
    return response.data
  },
  createSerp: function (storage, { clientId, serp }) {
    return httpService.post(`/serp-tracker/${clientId}`, serp,
      { successMessage: 'Indexation successfully created', raiseError: true, cancelErrorMessage: true })
  },
  updateSerp: function (storage, { clientId, serp }) {
    return httpService.patch(`/serp-tracker/${clientId}`, serp,
      { successMessage: 'Indexation successfully updated', raiseError: true, cancelErrorMessage: true })
  },
  deleteSerpById: function (storage, { clientId, serpId }) {
    const config = {
      params: {
        id: serpId
      },
      successMessage: 'Indexation successfully deleted',
      raiseError: true,
      cancelErrorMessage: true
    }
    return httpService.delete(`/serp-tracker/${clientId}`, config)
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
